<template>
    <svg :class="`icon icon-${name}`">
        <use
            :href="svgUrl"
            :xlink:href="svgUrl"
        />
    </svg>
</template>

<script>
    import Config from '../../config';

    export default {
        name: 'PacosIcon',
        props: {
            name: {
                type: String,
                default: '',
            },
            icon: {
                type: String,
                default: '',
            },
        },
        data() {
            const { svgSpritePath } = Config.options;

            return {
                svgSpritePath,
            };
        },
        computed: {
            iconName() {
                return this.icon || this.name;
            },
            svgUrl() {
                return `${this.svgSpritePath}#${this.name}`;
            },
        },
    };
</script>
